import { defineAdminIndexFiltersStorageController } from "../utils/admin_index_filters_storage"

const SKIP_FORM_MERGE_KEYS = new Set(["authenticity_token", "utf8", "commit", "button"])
const DEFAULT_LIMIT = "20"

function articlesIndexPathSuffix(pathname) {
  return /\/administration\/articles$/.test(pathname || "")
}

function mergeArticlesIndexQueryWithDom(search) {
  const params = new URLSearchParams(search && search !== "?" ? search.replace(/^\?/, "") : "")

  function mergeMissingFromForm(formId) {
    const form = document.getElementById(formId)
    if (!form) return

    const fd = new FormData(form)

    for (const [key, val] of fd.entries()) {
      if (val === "" || val == null) continue
      if (SKIP_FORM_MERGE_KEYS.has(key)) continue

      const cur = params.get(key)
      if (cur === null || cur === "") params.set(key, val)
    }
  }

  mergeMissingFromForm("admin-articles-index-search-form")
  mergeMissingFromForm("admin-articles-index-published-filter-form")

  const input = document.getElementById("admin-articles-index-search-input")
  const qDom = input?.value?.trim()
  if (qDom) params.set("q", qDom)

  const published = (params.get("published") || "").trim()
  if (published === "all") params.delete("published")

  const out = params.toString()
  return out === "" ? "" : `?${out}`
}

function hasPersistableArticlesIndexFilterParams(searchParams) {
  if ((searchParams.get("q") || "").trim()) return true

  const published = (searchParams.get("published") || "").trim()
  if (published === "published" || published === "unpublished") return true

  const limit = searchParams.get("limit")
  if (limit && limit !== DEFAULT_LIMIT) return true

  const page = searchParams.get("page")
  if (page && page !== "1") return true

  return false
}

export default defineAdminIndexFiltersStorageController({
  storageKey: "things-to-do-app:adminArticlesIndexQuery",
  restoreInFlightKey: "things-to-do-app:adminArticlesIndexRestoreInFlight",
  isIndexPath: articlesIndexPathSuffix,
  mergeQueryWithDom: mergeArticlesIndexQueryWithDom,
  hasPersistableParams: hasPersistableArticlesIndexFilterParams,
  defaultHref: "/administration/articles",
  restoreVisitOptions: { frame: "admin-workspace" }
})
